import { Link } from 'react-router-dom';
import { stats } from '@/mocks/articles';

export default function AboutSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <span className="inline-block text-xs font-medium text-foreground-500 border border-foreground-300 rounded-full px-3 py-1 mb-6">
              关于每日吃瓜
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
              全网最全吃瓜平台
            </h2>
            <p className="text-2xl md:text-3xl font-heading font-light text-secondary-500 mb-8">
              你的专属八卦雷达
            </p>

            <div className="flex gap-10 mb-8">
              {stats.slice(0, 2).map((stat) => (
                <div key={stat.label}>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md">
              每日吃瓜创始团队深耕娱乐资讯行业多年，拥有50+独家信源渠道，为您提供第一手网红爆料和明星八卦内容。我们坚持快速、真实、有趣的内容理念，让每一位吃瓜群众都能第一时间掌握最新动态。
            </p>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer border-b border-primary-300 pb-1"
            >
              了解更多关于我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-3/5 relative">
            <div className="flex gap-4 items-start">
              <div className="w-[45%] mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20with%20warm%20lighting%2C%20glass%20walls%2C%20creative%20workspace%2C%20Chinese%20tech%20company%20interior%2C%20warm%20amber%20and%20beige%20tones%2C%20clean%20aesthetic%2C%20editorial%20interior%20photography%2C%20soft%20shadows&width=600&height=600&seq=about-img-01&orientation=squarish"
                  alt="每日吃瓜团队办公室"
                  className="w-full aspect-square object-cover rounded-lg"
                  title="每日吃瓜团队办公环境"
                  loading="lazy"
                />
              </div>
              <div className="w-[55%]">
                <img
                  src="https://readdy.ai/api/search-image?query=Creative%20team%20working%20on%20laptops%20in%20modern%20office%2C%20warm%20atmospheric%20lighting%2C%20content%20creation%20workspace%2C%20Chinese%20media%20company%2C%20professional%20yet%20casual%20vibe%2C%20warm%20golden%20hour%20light%2C%20editorial%20photography%2C%20soft%20bokeh%20background&width=600&height=800&seq=about-img-02&orientation=portrait"
                  alt="每日吃瓜内容团队"
                  className="w-full aspect-[3/4] object-cover rounded-lg"
                  title="每日吃瓜内容创作团队"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}